/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

// Utilities
import Header from '../../components/header/index'
import Hero from '../../components/heros/index'
import Container from '../../components/container'
import Plan from '../../components/plan'
import Item from '../../components/planItem'
import Primary from '../../components/buttons/primary'
import Features from '../../components/features'
import BudgetLocation from '../../components/budgetlocation'
import Panel from '../../components/panel'
import CTO from '../../components/cto'
import Footer from '../../components/footer'
import Title from '../../components/title'

const BudgetMinecraft = () => {
    Title('Minecraft Server - StellaNode')
    return (
        <main>
            <div className="bg-primary-light mb-10">
                <Header />
                <Hero type='primary' title='North American Budget Minecraft Hosting' description='Get started by selecting a Minecraft Server plan below' />
            </div>
            <section className="plans py-28">
                <Container>
                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-20 gap-y-16 mb-16">
                        <Plan title='Copper Plan' price='3.00' renewal='monthly' link='minecraft-budget-na/copper-plan-1'>
                            <Item title='Intel® Xeon® E5-2696 v2 Or Equivalent' />
                            <Item title='4 GB DDR3 RAM' />
                            <Item title='50 GB Enterprise HDD Storage' />
                            <Item title='Path.net DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Iron Plan' price='4.50' renewal='monthly' link='minecraft-budget-na/iron-plan-1'>
                            <Item title='Intel® Xeon® E5-2696 v2 Or Equivalent' />
                            <Item title='6 GB DDR3 RAM' />
                            <Item title='50 GB Enterprise HDD Storage' />
                            <Item title='Path.net DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Gold Plan' price='6.00' renewal='monthly' link='minecraft-budget-na/gold-plan-1'>
                            <Item title='Intel® Xeon® E5-2696 v2 Or Equivalent' />
                            <Item title='8 GB DDR3 RAM' />
                            <Item title='50 GB Enterprise HDD Storage' />
                            <Item title='Path.net DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Diamond Plan' price='7.50' renewal='monthly' link='minecraft-budget-na/diamond-plan-1'>
                            <Item title='Intel® Xeon® E5-2696 v2 Or Equivalent' />
                            <Item title='10 GB DDR3 RAM' />
                            <Item title='50 GB Enterprise HDD Storage' />
                            <Item title='Path.net DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Emerald Plan' price='9.00' renewal='monthly' link='minecraft-budget-na/emerald-plan-1'>
                            <Item title='Intel® Xeon® E5-2696 v2 Or Equivalent' />
                            <Item title='12 GB DDR3 RAM' />
                            <Item title='50 GB Enterprise HDD Storage' />
                            <Item title='Path.net DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Quartz Plan' price='10.50' renewal='monthly' link='minecraft-budget-na/quartz-plan-1'>
                            <Item title='Intel® Xeon® E5-2696 v2 Or Equivalent' />
                            <Item title='14 GB DDR3 RAM' />
                            <Item title='50 GB Enterprise HDD Storage' />
                            <Item title='Path.net DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Netherite Plan' price='12' renewal='monthly' link='minecraft-budget-na/netherite-plan-1'>
                            <Item title='Intel® Xeon® E5-2696 v2 Or Equivalent' />
                            <Item title='16 GB DDR3 RAM' />
                            <Item title='50 GB Enterprise HDD Storage' />
                            <Item title='Path.net DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Crystal Plan' price='24' renewal='monthly' link='minecraft-budget-na/netherite-plan-1'>
                            <Item title='Intel® Xeon® E5-2696 v2 Or Equivalent' />
                            <Item title='32 GB DDR3 RAM' />
                            <Item title='150 GB Enterprise HDD Storage' />
                            <Item title='Path.net DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                    </div>
                    <div className='bg-primary-light shadow-xl p-8 rounded-md text-center'>
                        <h1 className='text-gray-100 font-medium text-2xl mb-2.5'>Unsure what plan is best for you?</h1>
                        <p className='text-gray-300 mb-7'>Contact us and we will help you pick the right choice for your needs.</p>
                        <div className='flex justify-center'>
                            <Primary rounded='sm' arrow={true} length='sm' link='https://billing.stellanode.com/submitticket.php'>Contact Us</Primary>
                        </div>
                    </div>
                </Container>
            </section>
            <Features />
            <Panel />
            <CTO />
            <Footer />
        </main>
    )
}

export default BudgetMinecraft